import React, {useRef, useState} from "react";
import MainButton from "../../commons/mainButton";
import {
    colorBookingPaid,
    colorStatus,
    GLOBAL_BACKGROUND_POPUP_ABSOLUTE,
    GLOBAL_BORDER_RADIUS,
    HIGHLIGHT_COLOR,
    orderStatus
} from "../../../costants";
import Loader from "../../commons/loader";
import MyNormalText from "../../commons/myNormalText";
import ItemBox from "../item/itemBox";
import CommonPopup from "../../commons/commonPopup";
import MyIcon from "../../commons/myIcon";
import useMyClickOutListener from "../../../global/listeners/useMyClickOutListener";
import {useReactToPrint} from "react-to-print";
import MyToggle from "../../commons/myToggle";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../../firebase";

function ManualBookingDetail({
                                 rentUser,
                                 premiumPalette,
                                 booking,
                                 isFromPremiumSection,
                                 loadingBooking,
                                 setIsOpen,
                                 handleSwitchToUpdateManualBooking,
                                 handleDeleteManualBooking,
                                 handleUpdateIsPaidBooking,
                                 handleUpdateIsDeliveredBooking,
                                 handleUpdateItemsReturnedUpBooking
                             }) {

    const primaryColorSecondAlternative = premiumPalette.primaryColorSecondAlternative
    const primaryColor = premiumPalette.primaryColor
    const primaryColorFourthAlternative = premiumPalette.primaryColorFourthAlternative

    const [openPopupDeleteBooking, setOpenPopupDeleteBooking] = useState(false)
    const [loadingPaymentLink, setLoadingPaymentLink] = useState(false)
    const [openEmailModal, setOpenEmailModal] = useState(false)
    const [customClientEmail, setCustomClientEmail] = useState("")

    const bookingDetailRef = useRef()
    const bookingDetailPrintRef = useRef()

    const isSingleDayRent = booking.isSingleDayRent
    const singleDaySlot = booking.orderDates?.singleDaySlot
    const isPaymentLinkEnabled = rentUser?.paymentLinkConfiguration?.isEnabled

    useMyClickOutListener(bookingDetailRef, () => setIsOpen(false))

    function getStatus() {
        if (booking.status === orderStatus.ACCEPTED) {
            return (
                <div style={{...pageStyle.bookingInfo, ...{backgroundColor: colorStatus.ACCEPTED}}}>
                    <MyIcon icon={require("../../../imgs/booking/status.png")}
                            name={'status'}
                            width={pageStyle.imageInfo.width}
                            height={pageStyle.imageInfo.height}/>
                    <div style={pageStyle.columnInfo}>
                        <MyNormalText text={'Stato'}
                                      bold={true}/>
                        <MyNormalText text={'Accettato'}/>
                    </div>
                </div>
            )
        }
    }

    function getOrderDates() {
        if (booking.orderDates.to) {
            return (
                <div
                    style={{...pageStyle.bookingInfo, ...{backgroundColor: primaryColorFourthAlternative}}}>
                    <MyIcon icon={require("../../../imgs/booking/calendar.png")}
                            name={'dates'}
                            width={pageStyle.imageInfo.width}
                            height={pageStyle.imageInfo.height}/>
                    <div style={pageStyle.columnInfo}>
                        <MyNormalText text={'Date richieste'}
                                      bold={true}/>
                        <MyNormalText text={'da ' + booking.orderDates.from + ' a ' + booking.orderDates.to}/>
                    </div>
                </div>
            )
        }

        return (
            <div style={{...pageStyle.bookingInfo, ...{backgroundColor: primaryColorFourthAlternative}}}>
                <MyIcon icon={require("../../../imgs/booking/calendar.png")}
                        name={'dates'}
                        width={pageStyle.imageInfo.width}
                        height={pageStyle.imageInfo.height}/>
                <div style={pageStyle.columnInfo}>
                    <MyNormalText text={'Data richiesta'}
                                  bold={true}/>
                    <MyNormalText text={booking.orderDates.from}/>
                </div>
            </div>
        )
    }

    function createSlotDescription() {
        return singleDaySlot?.from + ' - ' + singleDaySlot?.to + ' (' + singleDaySlot?.description + ')'
    }

    function calculateIsPaidBookingSection() {
        function getPaidStyle() {
            const backgroundColor = booking.isPaid ? colorBookingPaid.YES : colorBookingPaid.NO
            return {...pageStyle.bookingInfo, backgroundColor: backgroundColor}
        }

        return (
            <div style={pageStyle.subHeaderRow}>
                <div style={getPaidStyle()}>
                    <MyIcon icon={require("../../../imgs/booking/paid.png")}
                            name={'Paid'}
                            width={pageStyle.imageInfo.width}
                            height={pageStyle.imageInfo.height}/>
                    <div style={pageStyle.columnInfo}>
                        <MyNormalText text={'Pagato'}
                                      bold={true}/>
                        <MyNormalText text={booking.isPaid ? 'Sì' : 'No'}/>
                    </div>
                </div>
            </div>
        )
    }

    const handlePrint = useReactToPrint({
        contentRef: bookingDetailPrintRef,
        documentTitle: booking.orderId,
        suppressErrors: true,
        preserveAfterPrint: true
    })

    function handlePaymentLinkClick() {
        const clientEmail = booking.client?.email?.trim()
        if (!clientEmail) {
            setCustomClientEmail("")
            setOpenEmailModal(true)
        } else {
            executeCreatePaymentLink(clientEmail)
        }
    }

    function executeCreatePaymentLink(emailToUse) {
        if (!emailToUse || !emailToUse.includes("@")) {
            alert("Inserisci un'indirizzo e-mail valido.")
            return
        }

        setLoadingPaymentLink(true)
        const rentCreatePaymentLinkCommand = httpsCallable(functions, 'rentCreatePaymentLinkCommand')

        rentCreatePaymentLinkCommand({
            rentId: rentUser.rentId,
            bookingAmount: booking.total,
            orderId: booking.orderId,
            clientEmail: emailToUse,
            clientName: booking.client?.name || ""
        }).then(() => {
            setLoadingPaymentLink(false)
            setOpenEmailModal(false)
            alert('Link di pagamento generato e inviato con successo a ' + emailToUse)
        }).catch((err) => {
            setLoadingPaymentLink(false)
            alert('Ooops! Si è verificato un errore durante la generazione del link: ' + (err.message || ''))
        })
    }

    return (
        <div style={pageStyle.containerFullPageOpacity}>
            {loadingBooking || loadingPaymentLink ?
                <Loader absoluteFullPage={true}/> :
                <div ref={bookingDetailRef}
                     style={pageStyle.container}>
                    <div ref={bookingDetailPrintRef}
                         style={{...pageStyle.booking, backgroundColor: primaryColorSecondAlternative}}>
                        <div style={{...pageStyle.headerRow, backgroundColor: primaryColor}}>
                            <MyNormalText text={'Ordine manuale'}
                                          bold={true}/>
                        </div>
                        {calculateIsPaidBookingSection()}
                        <div style={pageStyle.bookingInfoContainer}>
                            {getStatus()}
                            <div style={{...pageStyle.bookingInfo, backgroundColor: primaryColorFourthAlternative}}>
                                <MyIcon icon={require("../../../imgs/booking/id.png")}
                                        name={'id'}
                                        width={pageStyle.smallerImageInfo.width}
                                        height={pageStyle.smallerImageInfo.height}/>
                                <div style={pageStyle.columnInfo}>
                                    <MyNormalText text={'Codice ordine'}
                                                  bold={true}/>
                                    <MyNormalText text={booking.orderId}/>
                                </div>
                            </div>
                            <div style={{...pageStyle.bookingInfo, backgroundColor: primaryColorFourthAlternative}}>
                                <MyIcon icon={require("../../../imgs/booking/user.png")}
                                        name={'user'}
                                        width={pageStyle.smallerImageInfo.width}
                                        height={pageStyle.smallerImageInfo.height}/>
                                <div style={pageStyle.columnInfo}>
                                    <MyNormalText text={'Ordine di'}
                                                  bold={true}/>
                                    <MyNormalText text={booking.client?.name || '-'}/>
                                </div>
                            </div>
                            <div
                                style={{...pageStyle.bookingInfo, backgroundColor: primaryColorFourthAlternative}}>
                                <MyIcon icon={require("../../../imgs/booking/email.png")}
                                        name={'email'}
                                        width={pageStyle.smallerImageInfo.width}
                                        height={pageStyle.smallerImageInfo.height}/>
                                <div style={pageStyle.columnInfo}>
                                    <MyNormalText text={'E-Mail'}
                                                  bold={true}/>
                                    <MyNormalText text={booking.client?.email || '-'}/>
                                </div>
                            </div>
                            {getOrderDates()}
                            {isSingleDayRent ?
                                <div style={{...pageStyle.bookingInfo, backgroundColor: primaryColorFourthAlternative}}>
                                    <MyIcon icon={require("../../../imgs/booking/single-day-rent.png")}
                                            name={'sent time'}
                                            width={pageStyle.imageInfo.width}
                                            height={pageStyle.imageInfo.height}/>
                                    <div style={pageStyle.columnInfo}>
                                        <MyNormalText text={'Fascia oraria'}
                                                      bold={true}/>
                                        <MyNormalText text={createSlotDescription()}/>
                                    </div>
                                </div> :
                                <></>}
                            <div style={{...pageStyle.bookingInfo, backgroundColor: primaryColorFourthAlternative}}>
                                <MyIcon icon={require("../../../imgs/booking/detail.png")}
                                        name={'total'}
                                        width={pageStyle.imageInfo.width}
                                        height={pageStyle.imageInfo.height}/>
                                <div style={pageStyle.columnInfo}>
                                    <MyNormalText text={'Totale'}
                                                  bold={true}/>
                                    <MyNormalText text={'€ ' + booking.total}/>
                                </div>
                            </div>
                        </div>
                        <div style={{...pageStyle.containerNotes, backgroundColor: primaryColorFourthAlternative}}>
                            <MyIcon icon={require("../../../imgs/booking/notes.png")}
                                    name={'notes'}
                                    width={pageStyle.imageInfo.width}
                                    height={pageStyle.imageInfo.height}/>
                            <div style={pageStyle.columnInfo}>
                                <MyNormalText text={'Note'}
                                              bold={true}/>
                                <MyNormalText text={booking.notes}/>
                            </div>
                        </div>
                        <div style={pageStyle.containerItems}>
                            {booking.items?.map(item => {
                                return (
                                    <div key={item.item.id}>
                                        <ItemBox rentUser={rentUser}
                                                 premiumPalette={premiumPalette}
                                                 item={item.item}
                                                 hidePrices={true}
                                                 openOperations={false}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div style={pageStyle.containerActionButtons}>
                        {isFromPremiumSection ?
                            <div style={{display: 'flex', gap: 10, flexWrap: 'wrap'}}>
                                <MyToggle title={'Pagato?'}
                                          onToggle={() => handleUpdateIsPaidBooking(!booking.isPaid)}
                                          isActive={booking.isPaid}
                                          premiumPalette={premiumPalette}/>
                                <MyToggle title={'Articoli ritirati?'}
                                          onToggle={() => handleUpdateIsDeliveredBooking(!booking.itemsPickedUp)}
                                          isActive={booking.itemsPickedUp}
                                          premiumPalette={premiumPalette}/>
                                <MyToggle title={'Articoli riconsegnati?'}
                                          onToggle={() => handleUpdateItemsReturnedUpBooking(!booking.itemsReturned)}
                                          isActive={booking.itemsReturned}
                                          premiumPalette={premiumPalette}/>
                                <div>
                                    <MainButton text={'Stampa'}
                                                action={handlePrint}
                                                secondaryImage={require('../../../imgs/actions/print.png')}
                                                backgroundColor={premiumPalette.primaryColorFourthAlternative}/>
                                </div>
                                {isPaymentLinkEnabled && !booking.isPaid ?
                                    <div>
                                        <MainButton text={'Invia link di pagamento'}
                                                    action={handlePaymentLinkClick}
                                                    backgroundColor={primaryColor}/>
                                    </div> : null}
                            </div> :
                            <></>}
                        {handleDeleteManualBooking && handleSwitchToUpdateManualBooking ?
                            <div style={{display: 'flex', justifyContent: 'space-between', gap: 10}}>
                                <MainButton text={'Modifica ordine'}
                                            action={() => handleSwitchToUpdateManualBooking(booking)}
                                            backgroundColor={premiumPalette.secondaryColor}/>
                                <MainButton text={'Cancella ordine'}
                                            action={() => setOpenPopupDeleteBooking(true)}
                                            backgroundColor={HIGHLIGHT_COLOR}/>

                            </div> :
                            <></>}
                        {openPopupDeleteBooking ?
                            <CommonPopup message={'Sei sicuro di voler cancellare l\'ordine?'}
                                         premiumPalette={premiumPalette}
                                         firstButtonText={'Conferma'}
                                         firstButtonColor={HIGHLIGHT_COLOR}
                                         firstButtonAction={() => handleDeleteManualBooking(booking.bookingId)}
                                         secondButtonText={'Annulla'}
                                         secondButtonColor={primaryColor}
                                         secondButtonAction={() => setOpenPopupDeleteBooking(false)}
                                         setIsOpen={setOpenPopupDeleteBooking}/> :
                            <></>}
                        {openEmailModal ?
                            <div style={pageStyle.modalOverlay}>
                                <div style={{...pageStyle.modalContent, backgroundColor: primaryColorSecondAlternative}}>
                                    <MyNormalText text={'Inserisci l\'email del cliente'} bold={true}/>
                                    <input type="email"
                                           placeholder="cliente@email.com"
                                           value={customClientEmail}
                                           onChange={(e) => setCustomClientEmail(e.target.value)}
                                           style={pageStyle.emailInput}/>
                                    <div style={{display: 'flex', gap: 10, justifyContent: 'center', marginTop: 15}}>
                                        <MainButton text={'Invia Link'}
                                                    action={() => executeCreatePaymentLink(customClientEmail)}
                                                    backgroundColor={primaryColor}/>
                                        <MainButton text={'Annulla'}
                                                    action={() => setOpenEmailModal(false)}
                                                    backgroundColor={HIGHLIGHT_COLOR}/>
                                    </div>
                                </div>
                            </div> : null}
                    </div>
                </div>}
        </div>
    )
}

const pageStyle = {
    containerFullPageOpacity: {
        zIndex: 1,
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: GLOBAL_BACKGROUND_POPUP_ABSOLUTE,
        overflowY: 'scroll'
    },
    container: {
        position: 'absolute',
        left: '50%',
        top: '5%',
        transform: 'translate(-50%, 0)',
        width: 'calc(100% / 2)',
        zIndex: 1
    },
    booking: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        padding: 20,
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    containerItems: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 10
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    subHeaderRow: {
        display: 'flex'
    },
    bookingInfoContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: 10
    },
    bookingInfo: {
        display: 'flex',
        padding: 5,
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    containerNotes: {
        display: 'flex',
        padding: 5,
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    containerActionButtons: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 20,
        marginBottom: 20,
        gap: 10
    },
    imageInfo: {
        height: 24,
        width: 24
    },
    smallerImageInfo: {
        height: 19,
        width: 19
    },
    columnInfo: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 5
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: GLOBAL_BACKGROUND_POPUP_ABSOLUTE,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10
    },
    modalContent: {
        padding: 20,
        borderRadius: GLOBAL_BORDER_RADIUS,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        width: 320,
        textAlign: 'center'
    },
    emailInput: {
        padding: 10,
        borderRadius: GLOBAL_BORDER_RADIUS,
        border: '1px solid #ccc',
        fontSize: 14,
        marginTop: 10
    }
}

export default ManualBookingDetail
